/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const CloseIcon: React.SFC = () => {
    return (
        <svg width="24" height="27" viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg">
            <g stroke="#555A77" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="square">
                <path d="M5.012 6.818L18.6 19.568M18.988 6.818L5.4 19.568" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Close/Close.tsx